import { VideoDurationTemplate } from './index';
import { Player, Render } from '../index';
import { UtilsService } from '../../services';


export class VideoDurationComponent {
    private _playerContainer: HTMLElement;
    private _durationElement: HTMLElement | null = null;

    /**
     * Get the main jw-wrapper element
     */
    private get wrapperElement(): HTMLElement {
        return <HTMLElement> this._playerContainer.querySelector('.jw-wrapper');
    }

    constructor(
        private _player: Player,
        private $document: Document = document,
        private util: UtilsService = UtilsService.Instance,
        private $render: any = Render) {
            this._playerContainer = this._player.playerContainer;
        }

    /**
     * Render the video duration
     */
    public render() {
        const media = this._player?.currentMediaData;
        // Get the video duration and format it as hh:mm:ss
        const duration = this.util.formatDuration(media?.metadata?.duration) ?? '';

        // Create the video duration element
        const videoDurationElement = this.$document.createElement('div');
        videoDurationElement.innerHTML = this.$render(VideoDurationTemplate, { duration });

        this._durationElement = videoDurationElement.firstElementChild as HTMLElement;

        // Add the video duration element to the main player wrapper
        if (this._durationElement) {
            this.wrapperElement.appendChild(this._durationElement);
        }
    }

    /**
     * Remove the video player duration element if necessary
     */
    public removeVideoPlayerDuration() {
        if (this._durationElement) {
            this._durationElement.remove();
            this._durationElement = null;
        }
    }
}
